<div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
  <img src="assets/images/logo-OITO.png" width="250" class="mb-5" />
  <app-loading [diameter]="100" [strokeWidth]="10" class="mb-3"></app-loading>
</div>
